import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = { class: "main-footer__container container" }
const _hoisted_3 = { class: "main-footer__one" }
const _hoisted_4 = { class: "main-footer__list-categories" }
const _hoisted_5 = {
  key: 0,
  class: "main-footer__item"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "main-footer__link",
  href: ""
}, "Каталог", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "main-footer__item"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "main-footer__link",
  href: ""
}, "Рецепты", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "main-footer__item" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<ul class=\"main-footer__list-info\"><li class=\"main-footer__item\"><a class=\"main-footer__link\" href=\"tel:88002508925\">8 (800) 250-8-925</a></li><li class=\"main-footer__item\"><a class=\"main-footer__link\" href=\"mailto:info@agrokomplexshop.ru\">info@agrokomplexshop.ru</a></li></ul>", 1)
const _hoisted_13 = { class: "main-footer__two" }
const _hoisted_14 = { class: "main-footer__two--container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "main-footer__organization" }, " © 1991-2023 АО фирма «Агрокомплекс» им. Н.И. Ткачёва ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "main-footer__address" }, " Краснодарский край, ст. Выселки, ул. Степная, 1 | ИНН 2328000083 | ОГРН 1022303554635 ", -1)
const _hoisted_17 = { class: "main-footer__descr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          false
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showFeedback && _ctx.showFeedback(...args))),
              class: "main-footer__link"
            }, "Обратная связь")
          ])
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPersonalData && _ctx.showPersonalData(...args)))
            }, "Политика конфиденциальности")
          ])
        ])
      ])
    ])
  ]))
}